<h1 mat-dialog-title style="display: flex; margin: 10px;">
  <ng-container>
    @if (IsNewAgreement) {
      <span style="flex: 1;">Create Vendor Agreement</span>
    }
    @if (!IsNewAgreement) {
      <span style="flex: 1;">Edit Vendor Agreement</span>
    }

    <span matTooltip="{{activeToggleTooltip()}}">
      {{Agreement.Active ? "Active " : "Inactive "}}
      <mat-slide-toggle style="margin-left: 5px;" color="accent" [disabled]="!Agreement.Id || !CanActivate" [checked]="Agreement.Active" (change)="ToggleActive(agreementEditForm)">
      </mat-slide-toggle>
    </span>
  </ng-container>
</h1>

<div mat-dialog-content #modalContainer scrollInsetShadow>
  <form name="agreement-edit-form" #agreementEditForm="ngForm" style="padding-bottom: 15px;">
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field>
          <mat-label>Agreement Number</mat-label>
          <input matInput required name="agreement-number" #agreementNumber="ngModel" maxlength="50" [(ngModel)]="Agreement.AgreementNumber">
          @if (agreementNumber.errors?.required) {
            <mat-error>
              Agreement Number is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field>
          <mat-label>Type</mat-label>
          <mat-select panelClass="standard-modal-panel" required [(ngModel)]="Agreement.AgreementType" #agreementType="ngModel" name="agreement-type">
            @for (a of Dropdowns.AgreementTypes; track a) {
              <mat-option [value]="a.Id">{{a.Description}}</mat-option>
            }
          </mat-select>
          @if (agreementType.errors?.required) {
            <mat-error>
              Type is required
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field style="margin-bottom: 10px;">
          <mat-label>Effective Start Date</mat-label>
          <input #startDatePickerModel="ngModel" matInput required (click)="startDate.open()"
            [matDatepicker]="startDate" [(ngModel)]="Agreement.EffectiveStartDate" name="startDate">
            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
            @if (startDatePickerModel.errors?.required) {
              <mat-error>
                Start Date is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field style="margin-bottom: 10px;">
            <mat-label>Effective End Date</mat-label>
            <input #endDatePickerModel="ngModel" matInput required (click)="endDate.open()" [min]="Agreement.EffectiveStartDate"
              [matDatepicker]="endDate" [(ngModel)]="Agreement.EffectiveEndDate" name="endDate">
              <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
              <mat-datepicker #endDate></mat-datepicker>
              @if (endDatePickerModel.errors?.required) {
                <mat-error>
                  End Date is required
                </mat-error>
              }
              @if (endDatePickerModel.errors?.matDatepickerMin) {
                <mat-error>
                  End Date must be after Start Date
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Payment Plan</mat-label>
              <mat-select panelClass="standard-modal-panel" [(ngModel)]="Agreement.PaymentPlan" #paymentPlan name="payment-plan">
                @for (a of Dropdowns.PaymentPlans; track a) {
                  <mat-option [value]="a.Id">{{a.Description}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <mat-label>Timeline (Days)</mat-label>
              <input matInput numbersOnly name="timeline" #timeline="ngModel" [(ngModel)]="Agreement.Timeline">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field>
              <mat-label>Comments</mat-label>
              <textarea matInput [(ngModel)]="Agreement.Comments" maxlength="512" name="comments"></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>

    <div mat-dialog-actions style="display: flex">
      @if (!IsNewAgreement) {
        <div>
          <dl class="dl-horizontal modal-audit-info">
            @if (Agreement.CreatedByName != undefined && Agreement.CreatedByPersonId != 0) {
              <dt>Created:</dt>
            }
            @if (Agreement.CreatedByName != undefined && Agreement.CreatedByPersonId != 0) {
              <dd>{{ Agreement.CreatedDate | date:'d-LLL-y' }} by {{ Agreement.CreatedByName }}</dd>
            }
            @if (Agreement.UpdatedByName != undefined && Agreement.UpdatedByPersonId != 0) {
              <dt>Updated:</dt>
            }
            @if (Agreement.UpdatedByName != undefined && Agreement.UpdatedByPersonId != 0) {
              <dd>{{ Agreement.UpdatedDate | date:'d-LLL-y' }} by {{ Agreement.UpdatedByName }}</dd>
            }
          </dl>
        </div>
      }

      <span style="flex: 1 1 auto;"></span>
      <button mat-raised-button color="accent" (click)="CancelModal()">Cancel</button>
      <button mat-raised-button color="primary" (click)="SaveAgreement(agreementEditForm, false)">Save</button>
      <button mat-raised-button color="primary" (click)="SaveAgreement(agreementEditForm, true)">Save &amp; Close</button>
    </div>
